import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-shifts" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card__header" }
const _hoisted_4 = { class: "card__header--title" }
const _hoisted_5 = { class: "card__header--status" }
const _hoisted_6 = { class: "card__body" }
const _hoisted_7 = { class: "card__body--time" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "card__body--time" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "add__card--icon" }
const _hoisted_12 = { class: "modal__footer" }
const _hoisted_13 = { class: "modal__footer--actions" }
const _hoisted_14 = { class: "modal__footer" }

import Filter from "@/features/shifts/ui/filter.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import {useShiftStore} from "@/features/shifts/shifts.store";
import {IShift} from "@/features/shifts/shifts.types";
import {onMounted, ref, watch} from "vue";
import {Trash01, Plus} from "utruckin-icons";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import Checkbox from "@/features/shifts/ui/checkbox.vue";
import {useAlert} from "@/utils/alert";
import {useAppStore} from "@/store/app.store";
import CustomBadge from "@/components/custom/CustomBadge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShiftsView',
  setup(__props) {

const shiftStore = useShiftStore();
const appStore = useAppStore();
const {show} = useAlert()

const loading = ref<boolean>(true);
const list = ref<IShift[]>([]);

const editingModal = ref<boolean>(false);
const modalTitle = ref<string>("");
const modalItem = ref<IShift>({
  name: "",
  title: "",
  id: "0",
  start_time: "",
  end_time: "",
  is_active: false,
});

const isStartTimeComplete = ref(true)
const isEndTimeComplete = ref(true)

const deletingModal = ref<boolean>(false);
const deleteModalItem = ref<any>()

const getList = async () => {
  list.value = await shiftStore.getShifts(loading);
}

const edit = async (item?: IShift) => {
  if (item) {
    let newItem = await shiftStore.getShiftById(loading, item.id);
    modalTitle.value = 'Edit shift';
    modalItem.value = newItem
    editingModal.value = true;
  } else {
    modalTitle.value = 'Add shift';
    editingModal.value = true;
  }
}

const openDeleteModal = () => {
  deleteModalItem.value = modalItem.value;
  editingModal.value = false;
  deletingModal.value = true;
}

const deleteShift = async () => {
  let response = await shiftStore.deleteShift(loading, deleteModalItem.value.id);

  if (response.status === "ok") {
    show("Deleted successfully", "success");
    cancelDeleteButton()
    cancelEditButton()
    appStore.triggerRefresh()
  }
}

const cancelEditButton = () => {
  editingModal.value = false;
  closeModal()
}

const cancelDeleteButton = () => {
  deletingModal.value = false;
}

const saveEditButton = async () => {
  if (!modalItem.value.name && !modalItem.value.title && !modalItem.value.start_time && !modalItem.value.end_time) return
  let result;
  if (+modalItem.value.id) {
    let newRequest: any = {...modalItem.value}
    result = await shiftStore.updateShift(loading, newRequest, newRequest.id);
  } else {
    let newRequest: any = {...modalItem.value}
    delete newRequest.id;
    result = await shiftStore.createShift(loading, newRequest);
  }
  if (result) {
    show("Saved successfully", "success");
    cancelEditButton()
    appStore.triggerRefresh()
  }
}

const closeModal = () => {
  modalTitle.value = '';
  modalItem.value = {
    name: "",
    title: "",
    id: "0",
    start_time: "",
    end_time: "",
    is_active: false,
  };
}

const closeDeleteModal = () => {
  deleteModalItem.value = undefined;
}

const onStartTimeCompleted = (v: boolean) => {
  isStartTimeComplete.value = v
}

const onEndTimeCompleted = (v: boolean) => {
  isEndTimeComplete.value = v
}

onMounted(() => {
  getList()
})

watch(
    () => appStore.refreshKey,
    () => {
      getList()
    },
    {
      immediate: false,
    }
)

watch(
    () => modalItem.value.title,
    (newVal) => {
      modalItem.value.name = newVal.trim().split(" ").join("_").toLowerCase();
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card",
          key: index,
          onClick: ($event: any) => (edit(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CustomBadge, {
                title: item['is_active'] ? 'Active' : 'Inactive',
                type: item['is_active'] ? 'success' : 'danger'
              }, null, 8, ["title", "type"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Start time", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.start_time), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "End time", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.end_time), 1)
            ])
          ])
        ], 8, _hoisted_2))
      }), 128)),
      _createElementVNode("div", {
        class: "card add",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (edit(undefined)))
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Plus), { size: 24 })
        ])
      ])
    ]),
    _createVNode(CommonModal, {
      modelValue: editingModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editingModal).value = $event)),
      title: modalTitle.value,
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "modal__footer--delete",
            onClick: openDeleteModal
          }, [
            _createVNode(_unref(Trash01), { size: 24 })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(CommonButton, {
              type: "secondary",
              label: "Cancel",
              onClicked: cancelEditButton
            }),
            _createVNode(CommonButton, {
              "is-disabled": 
            !modalItem.value.name ||
            !modalItem.value.title ||
            !modalItem.value.start_time ||
            !modalItem.value.end_time ||
            !isStartTimeComplete.value ||
            !isEndTimeComplete.value,
              type: "primary",
              label: "Save",
              onClicked: saveEditButton
            }, null, 8, ["is-disabled"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(CommonInput, {
            label: "Shift name",
            placeholder: "Shift name",
            "model-value": modalItem.value.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalItem.value.title) = $event)),
            error: !modalItem.value.title,
            errorMessage: "Value is required"
          }, null, 8, ["model-value", "error"]),
          _createVNode(CommonInput, {
            label: "Start time",
            placeholder: "Start time",
            mask: "##:##:##",
            modelValue: modalItem.value.start_time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalItem.value.start_time) = $event)),
            error: !modalItem.value.start_time || !isStartTimeComplete.value,
            errorMessage: "Value is required",
            "onMask:completed": onStartTimeCompleted
          }, null, 8, ["modelValue", "error"]),
          _createVNode(CommonInput, {
            label: "End time",
            placeholder: "End time",
            mask: "##:##:##",
            "model-value": modalItem.value.end_time,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalItem.value.end_time) = $event)),
            error: !modalItem.value.end_time || !isEndTimeComplete.value,
            errorMessage: "Value is required",
            "onMask:completed": onEndTimeCompleted
          }, null, 8, ["model-value", "error"]),
          _createVNode(Checkbox, {
            "model-value": modalItem.value.is_active,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modalItem.value.is_active) = $event)),
            label: "Active"
          }, null, 8, ["model-value"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(CommonModal, {
      modelValue: deletingModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((deletingModal).value = $event)),
      onClose: closeDeleteModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(CommonButton, {
            type: "secondary",
            label: "Cancel",
            onClicked: cancelDeleteButton
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: deleteShift
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "delete__title" }, " Are you sure you want to delete this shift? This action cannot be undone. ", -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})